export const TrackerIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0666 5.19978C11.7602 6.8934 11.7602 9.63931 10.0666 11.3329C8.37297 13.0266 5.62706 13.0266 3.93344 11.3329C2.23981 9.63931 2.23981 6.8934 3.93344 5.19978C5.62706 3.50615 8.37297 3.50615 10.0666 5.19978Z"
      fill="#009E7F"
      fillOpacity="0.683"
    />
    <path
      d="M12.3329 5.19978C14.0266 6.8934 14.0266 9.63931 12.3329 11.3329C10.6393 13.0266 7.89339 13.0266 6.19976 11.3329C4.50614 9.63931 4.50614 6.8934 6.19976 5.19978C7.89339 3.50615 10.6393 3.50615 12.3329 5.19978Z"
      fill="#009E7F"
      fillOpacity="0.683"
    />
  </svg>
);
